import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router'
import { clsx } from 'clsx'

import B2becButton from '@/components/B2becButton'
import Footer from '@/components/Layout/Footer'
import ScrollToTop from '@/components/ScrollToTop'
import { useAppDispatch, useAppSelector } from '@/store/hook'
import { authenticationActions, selectUserId } from '@/store/slices/authenticationSlice'
import useDocumentTitle from '@/hooks/useDocumentTitle'
import { linkGenerator } from '@/libs/utils/language'
import environment from '@/environments/environment.dev'

import styles from './LandingPage.module.scss'

const {
  aws: { cognito },
} = environment

const LandingPage = () => {
  useDocumentTitle('welcome welcome-subtext')
  const { t } = useTranslation()
  const location = useLocation()
  const dispatch = useAppDispatch()

  const userId = useAppSelector(selectUserId)

  const from = location.state?.from?.pathname || linkGenerator('/my-workspace')

  const handleLogin = () => {
    dispatch(
      authenticationActions.signInViaIdentityProvider({
        id: cognito.identityProvider.customers,
        from,
      }),
    )
  }

  if (userId) {
    return <Navigate replace to={from} />
  }

  return (
    <>
      <div className={styles.headerWrapper}>
        <div className={styles.headerContainer}>
          <h2 className={styles.headerWelcomeTitle}>{t('welcome')}</h2>
        </div>
        <div className={styles.headerContainer}>
          <h3 className={styles.headerWelcomeText}>{t('welcome-text')}</h3>
        </div>
      </div>
      <ScrollToTop />
      <div className={styles.contentContainer}>
        <B2becButton
          className={clsx('kaercher-button', styles.loginButton)}
          onClick={handleLogin}
        >
          {t('login')}
        </B2becButton>
      </div>
      <Footer />
    </>
  )
}

export default LandingPage
